import { useParams } from 'react-router-dom'
import Banner from '@/pages/components/common/Banner'
import useFetch from '@/api/useFetch';
import styles from './NewsDetail.module.less'

const Index = (props) => {
  const params = useParams()
  
  const { response } = useFetch('getNews', {
    field_name: 'qcmsdid',
    field_value: params.id
  })
  
  const article = response[0] || {}

  return (
    <>
      <Banner />
      <div className={`mod ${styles.article}`} style={{ marginBottom: "50px" }}>
        <h2 className={styles.title}>{article.title}</h2>
        <span className={styles.date}>{article.recordTime}</span>
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: article.content }}></div>
      </div>
    </>
  )
}

export default Index
